// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1971":"PlotlyEditor","2261":"plone-volto-components-theme-View-EventView","9335":"taxonomy-edit-tree"}[chunkId] + "." + {"1971":"7c55b863","2261":"e7823d10","9335":"bf3fb821"}[chunkId] + ".chunk.css";
};